import React from 'react'

import { GlobalStyle } from './GlobalStyle'
import { Routes } from './Routes'

function App () {
  return (
    <div>
      <Routes />
      <GlobalStyle />
    </div>
  )
}

export default App
